import { Company } from '../company/company';
import { HttpParams } from '@angular/common/http';

export class UserClientFilter {
	email: string;
	firstName: string;
	lastName: string;
	company: Company;

	constructor(filter?: UserClientFilter) {
		if (filter) {
			this.email = filter.email;
			this.firstName = filter.firstName;
			this.lastName = filter.lastName;
			this.company = filter.company;
		}
	}

	getHttpParams(httpParams = new HttpParams()): HttpParams {
		if (this.firstName) {
			httpParams = httpParams.set('firstName', this.firstName);
		}
		if (this.lastName) {
			httpParams = httpParams.set('lastName', this.lastName);
		}
		if (this.email) {
			httpParams = httpParams.set('email', this.email);
		}
		if (this.company && this.company.id) {
			httpParams = httpParams.set('companyId', this.company.id.toString());
		}
		return httpParams;
	}
}
